import React, { useEffect, useState, useContext } from "react";
import { Stack, Typography, Box, Grid } from "@mui/material";
import "./dashboard.scss";
import { useQuery } from "@apollo/client";
//Component
import AttendanceHeader from "../Components/Dashboard/AttendanceHeader";
import EmployeeStatisticsByDepartment from "../Components/Dashboard/EmployeeStatisticsByDepartment";
import EmployeeWorkforce from "../Components/Dashboard/EmployeeWorkforce";
import RequestAllowClass from "../Components/Dashboard/RequestAllowClass";
import DailyStaffStatisticsAfternoon from "../Components/Dashboard/DailyStaffStatisticsAfternoon";
import DailyStaffStatisticsMorning from "../Components/Dashboard/DailyStaffStatisticsMorning";
import IncomeByIncomeTypeChart from "../Components/Dashboard/IncomeByIncomeTypeChart";
import DialyIncomeChart from "../Components/Dashboard/DialyIncomeChart";
import { SelectAcademicYear } from "../Components/Include/DynamicSelect";
import { GET_ACTIVE_ACADEMIC_YEAR } from "../Schema/SelectSchema";

export default function Dashboard() {
  const [academicYearVal, setAcademicYearVal] = useState({
    id: "",
    title: "",
    endDate: null,
    startDate: null,
  });

  const { refetch: refetchAcademic } = useQuery(GET_ACTIVE_ACADEMIC_YEAR, {
    onCompleted: ({ getActiveAcademicYear }) => {
      setAcademicYearVal({
        id: getActiveAcademicYear?._id,
        title: getActiveAcademicYear?.academicYearName,
      });
    },
    onError: (error) => {
      console.log(error);
    },
  });

  return (
    <div className="dashboard-page">
      <Stack direction="row" spacing={2}>
        <Box className="slash" />
        <Stack direction="column" justifyContent="center">
          <Typography className="color">Dashboard</Typography>
        </Stack>
        <Box sx={{ flexGrow: 1 }} />
      </Stack>

      <Box sx={{ marginTop: "30px" }}>
        <Grid container spacing={3}>
          <Grid item xs={2.4}>
            <Typography className="search-head-title">Academic year</Typography>
            <SelectAcademicYear
              className="search-field"
              selectedVal={academicYearVal}
              setSelectedVal={setAcademicYearVal}
            />
          </Grid>
          <Grid item xs={12}>
            <AttendanceHeader academicYearId={academicYearVal?.id} />
          </Grid>
        </Grid>
        <Box sx={{ marginTop: "30px" }}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} xl={3}>
              <Box width="100%">
                <RequestAllowClass />
              </Box>
            </Grid>
            <Grid item xs={12} sm={9}>
              <Box width="100%">
                <IncomeByIncomeTypeChart />
              </Box>
            </Grid>
            <Grid item xs={12} sm={12}>
              <Box width="100%">
                <DialyIncomeChart academicYearId={academicYearVal?.id} title={academicYearVal?.title}/>
              </Box>
            </Grid>
            <Grid item xs={12} sm={12}></Grid>
            {/* <Grid item xs={12} sm={6}>
              <Box width="100%">
                <EmployeeWorkforce />
              </Box>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Box width="100%">
                <DailyStaffStatisticsMorning />
              </Box>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Box width="100%">
                <DailyStaffStatisticsAfternoon />
              </Box>
            </Grid> */}
          </Grid>
        </Box>
      </Box>
    </div>
  );
}
